import { messages } from '../en-US.js';
export function getMessage(locale, key) {
    const catalogue = messages[locale] ?? messages['en-US'];
    return catalogue[key];
}
export { messages };
//# sourceMappingURL=messages.js.map